import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Color } from 'three';
import { TextureInfo, TextureUsage } from './texture-info.js';
import { $correlatedObjects, $onUpdate, ThreeDOMElement } from './three-dom-element.js';
var $threeMaterial = Symbol('threeMaterial');
var $threeMaterials = Symbol('threeMaterials');
var $baseColorTexture = Symbol('baseColorTexture');
var $metallicRoughnessTexture = Symbol('metallicRoughnessTexture');
/**
 * PBR material properties facade implementation for Three.js materials
 */
export var PBRMetallicRoughness = /*#__PURE__*/function (_ThreeDOMElement) {
  _inherits(PBRMetallicRoughness, _ThreeDOMElement);
  var _super = _createSuper(PBRMetallicRoughness);
  function PBRMetallicRoughness(onUpdate, correlatedMaterials) {
    var _this;
    _classCallCheck(this, PBRMetallicRoughness);
    _this = _super.call(this, onUpdate, correlatedMaterials);
    var _correlatedMaterials$ = correlatedMaterials.values().next().value,
      map = _correlatedMaterials$.map,
      metalnessMap = _correlatedMaterials$.metalnessMap;
    _this[$baseColorTexture] = new TextureInfo(onUpdate, TextureUsage.Base, map, correlatedMaterials);
    _this[$metallicRoughnessTexture] = new TextureInfo(onUpdate, TextureUsage.MetallicRoughness, metalnessMap, correlatedMaterials);
    return _this;
  }
  _createClass(PBRMetallicRoughness, [{
    key: $threeMaterials,
    get: function get() {
      return this[$correlatedObjects];
    }
  }, {
    key: $threeMaterial,
    get: function get() {
      var _a;
      return (_a = this[$correlatedObjects]) === null || _a === void 0 ? void 0 : _a.values().next().value;
    }
  }, {
    key: "baseColorFactor",
    get: function get() {
      var rgba = [0, 0, 0, this[$threeMaterial].opacity];
      this[$threeMaterial].color.toArray(rgba);
      return rgba;
    }
  }, {
    key: "metallicFactor",
    get: function get() {
      return this[$threeMaterial].metalness;
    }
  }, {
    key: "roughnessFactor",
    get: function get() {
      return this[$threeMaterial].roughness;
    }
  }, {
    key: "baseColorTexture",
    get: function get() {
      return this[$baseColorTexture];
    }
  }, {
    key: "metallicRoughnessTexture",
    get: function get() {
      return this[$metallicRoughnessTexture];
    }
  }, {
    key: "setBaseColorFactor",
    value: function setBaseColorFactor(rgba) {
      var color = new Color();
      if (rgba instanceof Array) {
        color.fromArray(rgba);
      } else {
        color.set(rgba);
      }
      var _iterator = _createForOfIteratorHelper(this[$threeMaterials]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var material = _step.value;
          material.color.set(color);
          if (rgba instanceof Array && rgba.length > 3) {
            material.opacity = rgba[3];
          } else {
            rgba = [0, 0, 0, material.opacity];
            color.toArray(rgba);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setMetallicFactor",
    value: function setMetallicFactor(value) {
      var _iterator2 = _createForOfIteratorHelper(this[$threeMaterials]),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var material = _step2.value;
          material.metalness = value;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setRoughnessFactor",
    value: function setRoughnessFactor(value) {
      var _iterator3 = _createForOfIteratorHelper(this[$threeMaterials]),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var material = _step3.value;
          material.roughness = value;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this[$onUpdate]();
    }
  }]);
  return PBRMetallicRoughness;
}(ThreeDOMElement);